
import './BouquetNoteWrite.css';
import React, { useState } from "react";
import ribbons from '../assets/constants/ribbons.js';
import vases from '../assets/constants/vases.js';
import stickers from '../assets/constants/stickers.js';
import flowers from '../assets/constants/flowers.js';
import brickHeader from '../assets/images/brickHeader.png';
import dearText from '../assets/images/dearText.png';
import sincerelyText from '../assets/images/sincerelyText.png';
import StickerSelector from '../components/StickerSelector.js';
import leafCluster from '../assets/images/leafCluster.png';

function BouquetNoteWrite(props) {

    const [to, setTo] = useState(props.to);
    const [from, setFrom] = useState(props.from);
    const [note, setNote] = useState(props.note);

    const [showSticker, setShowSticker] = useState(true)

    const handleToChange = (event) => {
        setTo(event.target.value);
        props.setTo(event.target.value)
    };

    const handleFromChange = (event) => {
        setFrom(event.target.value);
        props.setFrom(event.target.value)
    };

    const handleNoteChange = (event) => {
        setNote(event.target.value);
        props.setNote(event.target.value)
    };

    function handleShareClick() {
        props.setActiveStatus("share your bouquet")
        window.scrollTo(0, 0)
    }

    return (
        <div>
            <img src={brickHeader} alt="e-florals flower shop sign on a white brick building" className="brickHeaderimage" />
            <div className="row">
                <div className="bouquetAssembleDisplay">
                    <div className="bouquetAssembleFlowerGroup">
                                                <img className="bouquetShareleafClusterImage bouquetNoteLeaf" src={leafCluster} alt="green leaf cluster"/>

                        {props.selectedFlowers.map((flower, index) => (
                            <img key={index} className={"flowerImageLarge flowerImage" + index} src={flowers[flower].img} alt={flowers[flower].name} />
                        ))}
                    </div>
                    <img className="bouquetAssembleVase" src={vases[props.selectedDisplay].src} alt={vases[props.selectedDisplay].alt} />
                    <img className="bouquetAssembleVase bouquetAssembleVaseBack" src={vases[props.selectedDisplay].backSrc} alt={vases[props.selectedDisplay].alt} />
                    <div className={ribbons[props.selectedRibbon].outlineClass === "ribbon ribbonSmall" ? "bouquetAssembleRibbon bouquetAssembleRibbonSmall" : "bouquetAssembleRibbon"}>
                        <img className="chosenRibbonBouquetAssembly outlineRibbonChosen" src={ribbons[props.selectedRibbon].outlineSrc} alt="outline of a bow" />
                        <img className="chosenRibbonBouquetAssembly" src={ribbons[props.selectedRibbon].src} alt={ribbons[props.selectedRibbon].alt} />
                    </div>
                    <div className="envelopeBox envelopeBoxNoteWrite">
                        <div class="firstBlackTriangle"></div>
                        <div class="secondBeigeTriangle"></div>
                        <img className="bouquetShareSticker" src={stickers[props.selectedSticker].src} alt={stickers[props.selectedSticker].alt} />
                    </div>
                    <div className="changeSection">
                                        <div className="changeSectionRibbon">
                        <p onClick={() => setShowSticker(!showSticker)} className="removeFlower changeSectionToggle"> {showSticker? "hide" : "show"} sticker selector</p>
                        {showSticker &&
                            <div>
                                <StickerSelector selectedSticker={props.selectedSticker} setSelectedSticker={props.setSelectedSticker}/>
                            </div>
                        }
                    </div>
                    </div>
                </div>
                <div className="writeNotePanel">
                    <div className="">
                        <img className="bouquetNoteText dearText" src={dearText} alt="dear" />
                        <textarea
                            className="noteWriteInput nameInput"
                            type="text"
                            id="description"
                            value={to}
                            onChange={handleToChange}
                            name="description"
                            spellCheck="false"
                        />
                    </div>
                    <textarea
                        className="noteWriteInput noteInput"
                        type="text"
                        id="description"
                        value={note}
                        onChange={handleNoteChange}
                        name="description"
                        spellCheck="false"
                    />
                    <div>
                        <img className="bouquetNoteText sincerelyText" src={sincerelyText} alt="sincerely" />
                        <textarea
                            className="noteWriteInput nameInput"
                            type="text"
                            id="description"
                            value={from}
                            onChange={handleFromChange}
                            name="description"
                            spellCheck="false"
                        />
                    </div>
                </div>
            </div>
            <p onClick={() => handleShareClick()} className="navButton startArrangingVaseButton"> share your bouquet </p>
        </div>
    )
}

export default BouquetNoteWrite;